// Routen und API-Pfade, die bewusst ohne Portal-Session funktionieren.
// Ein 401 darf hier nicht zum Login umleiten, sonst bricht z. B. das
// Kunden-Onboarding (Einladungslink) sofort ab.
// /recovery ist der öffentliche Selbst-Wiederherstellungs-Weg für ausgesperrte
// Administratoren; er hat per Definition keine Portal-Sitzung.
// /restore ist der Wiederherstellungs-Link, den die Wiederherstellungs-Kontakte
// nach einer kritischen Konfigurationsänderung per E-Mail erhalten. Auch er wird
// typischerweise ohne Portal-Sitzung geöffnet.
const PUBLIC_PATH_PREFIXES = ['/onboarding', '/recovery', '/restore']
const PUBLIC_API_PATH_PREFIXES = [
  '/api/registry/v1/onboarding',
  '/api/registry/v1/recovery',
  '/api/registry/v1/restore',
]

export const isPublicAppPath = (pathname = window.location.pathname) =>
  PUBLIC_PATH_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))

export const isPublicApiPath = (url?: string) =>
  Boolean(url) && PUBLIC_API_PATH_PREFIXES.some((prefix) => url!.includes(prefix))
